export default {
  state: {
    userGroupList: [],
    userGroupTitleList: [],
    userGroupSingle: null,
    accessList: []
  },
  mutations: {
    setUserGroupList (state, payload) {
      state.userGroupList = payload
      state.userGroupTitleList = []
      for (let i = 0; i < state.userGroupList.length; i++) {
        state.userGroupTitleList[i] = state.userGroupList[i].title
      }
    },
    setUserGroupSingle (state, payload) {
      state.userGroupSingle = payload
    },
    setAccessList (state, payload) {
      state.accessList = payload
    }
  },
  actions: {
    getUserGroupList ({commit, dispatch}) {
      const url = '/admin/user/group/list?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setUserGroupList', data.user_group_list)
        })
        .catch((error) => {
          throw error
        })
    },
    getUserGroupSingle ({commit, dispatch}, {id}) {
      const url = '/admin/user/group/' + id + '/single?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setUserGroupSingle', data.user_group)
        })
        .catch((error) => {
          throw error
        })
    },
    async createUserGroup ({commit, dispatch}, {id, title, accessIdList}) {
      let post = {
        data: {
          title: title
        }
      }

      if (id !== null && typeof id !== 'undefined') {
        post.data.id = id
      }
      if (typeof accessIdList !== 'undefined' ? accessIdList.length > 0 : false) {
        post.data.access_id_list = accessIdList
      }

      let returnData = null
      if (typeof post.data.id === 'undefined') {
        post.url = '/admin/user/group/add?access_token=' + this.getters.accessToken
        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Группа создана успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      } else {
        post.data.id = id
        post.url = '/admin/user/group/' + id + '/update?access_token=' + this.getters.accessToken

        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Группа изменена успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      }
      return returnData
    },
    deleteUserGroup ({commit, dispatch}, {id}) {
      let post = {
        data: {
          id: id
        }
      }

      post.url = '/admin/user/group/' + id + '/remove?access_token=' + this.getters.accessToken
      dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Группа удалена успешно')
        })
        .catch((error) => {
          throw error
        })
    },
    getAccessList ({commit, dispatch}) {
      const url = '/admin/access/list/?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setAccessList', data.access_list)
        })
        .catch((error) => {
          throw error
        })
    }
  },
  getters: {
    userGroupList (state) {
      return state.userGroupList
    },
    userGroupTitleList (state) {
      return state.userGroupTitleList
    },
    userGroupSingle (state) {
      return state.userGroupSingle
    },
    accessList (state) {
      return state.accessList
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user-group.js